/* SG — shared vanilla JS for all sg-* sections. No dependencies. Safe to include multiple times. */
(function () {
  if (window.__sgInit) return;
  window.__sgInit = true;

  /* Respect reduced motion: pause any autoplaying sg videos */
  function handleReducedMotion() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) return;
    document.querySelectorAll('.sg-media video[autoplay]').forEach(function (v) {
      try { v.pause(); v.removeAttribute('autoplay'); v.setAttribute('controls', ''); } catch (e) {}
    });
  }

  /* Gentle fade-in for elements marked .sg-fade */
  function initFade() {
    var els = document.querySelectorAll('.sg-fade');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product buy box: variant select -> price / availability / sticky bar sync */
  function money(cents, format) {
    var val = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount[^}]*\}\}/, val);
    }
    return '$' + val;
  }

  function initBuyBox(box) {
    if (box.dataset.sgReady) return;
    box.dataset.sgReady = '1';
    var dataEl = box.querySelector('[data-sg-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var format = box.dataset.moneyFormat || '';
    var select = box.querySelector('select[name="id"]');
    var priceEl = box.querySelector('[data-sg-price]');
    var compareEl = box.querySelector('[data-sg-compare]');
    var availEl = box.querySelector('[data-sg-availability]');
    var addBtn = box.querySelector('[data-sg-add]');
    var stickyPrice = document.querySelector('[data-sg-sticky-price="' + box.id + '"]');
    var qtyInput = box.querySelector('input[name="quantity"]');

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }
    function render(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price, format);
      if (stickyPrice) stickyPrice.textContent = money(v.price, format);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price, format);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (availEl) {
        availEl.textContent = v.available ? (availEl.dataset.inStock || 'In stock') : (availEl.dataset.soldOut || 'Sold out');
        availEl.classList.toggle('is-sold-out', !v.available);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.dataset.labelAdd || 'Add to cart') : (addBtn.dataset.labelSoldOut || 'Sold out');
      }
      var stickyBtn = document.querySelector('[data-sg-sticky-add="' + box.id + '"]');
      if (stickyBtn) { stickyBtn.disabled = !v.available; }
    }
    if (select) {
      select.addEventListener('change', function () { render(findVariant(select.value)); });
      render(findVariant(select.value));
    }
    /* quantity +/- */
    box.querySelectorAll('[data-sg-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        n += btn.dataset.sgQty === 'plus' ? 1 : -1;
        if (n < 1) n = 1;
        qtyInput.value = n;
      });
    });
  }

  /* Sticky mobile add-to-cart bar: show when buy box scrolls out of view, submit the real form */
  function initSticky() {
    document.querySelectorAll('[data-sg-sticky]').forEach(function (bar) {
      var targetId = bar.dataset.sgSticky;
      var box = document.getElementById(targetId);
      if (!box) return;
      var form = box.querySelector('form');
      var btn = bar.querySelector('[data-sg-sticky-add]');
      if (btn && form) {
        btn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        });
      }
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(box);
    });
  }

  /* Smooth-scroll for in-page anchors on sg buttons (respects reduced motion) */
  function initAnchors() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('a.sg-btn[href^="#"], .sg-header a[href^="#"], .sg-header a[href^="/#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var hash = a.getAttribute('href').replace(/^\//, '');
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', hash);
      });
    });
  }

  function init() {
    handleReducedMotion();
    initFade();
    document.querySelectorAll('[data-sg-buybox]').forEach(initBuyBox);
    initSticky();
    initAnchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Re-init when Shopify theme editor re-renders a section */
  document.addEventListener('shopify:section:load', init);
})();